import { Metamodel, DataFlowDSLAdapterRegistry, Owned } from 'shell-models-lib';
import { AdobeEventsSettings } from 'app/model/dataflow/dataset-settings/adobe-events-settings';
import { DatasetFormatType } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { DataFlowExpressionUtils } from '../expression.util';
import { IntegerDataFlowType } from 'app/model/dataflow/dataflow-datatype';
import { BaseFormatAdapter } from './base-format.adapter';
import { DataFlowSource } from 'app/model/dataflow/dataflow-source';

@DataFlowDSLAdapterRegistry.adapter({
    model: Metamodel.modelFor(AdobeEventsSettings)
})
export class AdobeEventsFormatAdapter extends BaseFormatAdapter<AdobeEventsSettings> {
    protected async toSourceDSL(settings: AdobeEventsSettings): Promise<string[]> {
        const props = [];
        props.push(`format: '${DatasetFormatType.AdobeIOEvents}'`);
        if (settings.lastPosition.expression) {
            props.push(
                `lastEventPosition: ${DataFlowExpressionUtils.wrapExpressionConfigValue(settings.lastPosition)}`
            );
        }
        if (settings.batchSize.expression) {
            props.push(
                `batchSize: ${DataFlowExpressionUtils.wrapExpressionConfigValue(
                    settings.batchSize,
                    IntegerDataFlowType.TYPE
                )}`
            );
        }
        if (settings.requestInterval.expression) {
            props.push(
                `requestInterval: ${DataFlowExpressionUtils.wrapExpressionConfigValue(
                    settings.requestInterval,
                    IntegerDataFlowType.TYPE
                )}`
            );
        }
        return props;
    }

    protected async toSourceModel(
        owner: DataFlowSource,
        configs: Map<string, string>,
        handledConfigs: string[]
    ): Promise<AdobeEventsSettings> {
        const eventsSettings = Owned.create<AdobeEventsSettings>(AdobeEventsSettings.MODEL, owner);
        eventsSettings.initialize(undefined);

        if (configs.has('lastEventPosition')) {
            eventsSettings.lastPosition = DataFlowExpressionUtils.unwrapExpressionConfigValue(
                configs.get('lastEventPosition'),
                owner
            );
            handledConfigs.push('lastEventPosition');
        }
        if (configs.has('batchSize')) {
            eventsSettings.batchSize = DataFlowExpressionUtils.unwrapExpressionConfigValue(
                configs.get('batchSize'),
                owner,
                IntegerDataFlowType.TYPE
            );
            handledConfigs.push('batchSize');
        }
        if (configs.has('requestInterval')) {
            eventsSettings.requestInterval = DataFlowExpressionUtils.unwrapExpressionConfigValue(
                configs.get('requestInterval'),
                owner,
                IntegerDataFlowType.TYPE
            );
            handledConfigs.push('requestInterval');
        }

        return eventsSettings;
    }
}
